<div class="tsd_container">
  <form [formGroup]="gstForm">
    <mat-card>
      <mat-card-content>
        <h4>Gst</h4>
        <mat-form-field style="width: 250px;">
          <mat-label>SAC code</mat-label>
          <input matInput placeholder="SAC code" formControlName="code" autocomplete="off" required>
          @if (code.invalid && code.touched && code.hasError('required')) {
            <mat-error>SAC Code is required</mat-error>
          }
        </mat-form-field>
        <mat-form-field style="width: 250px;">
          <mat-label>SAC Name</mat-label>
          <input matInput placeholder="SAC Name" formControlName="name" autocomplete="off" required>
          @if (name.invalid && name.touched && name.hasError('required')) {
            <mat-error>SAC Name is required</mat-error>
          }
        </mat-form-field>
        <mat-form-field style="width: 250px;">
          <mat-label>Description</mat-label>
          <input matInput placeholder="Description" formControlName="description" autocomplete="off">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Gst Type</mat-label>
          <mat-select formControlName="type" required placeholder="Gst Type">
            <mat-option [value]="null">None</mat-option>
            @for (type of gstTypes; track type) {
              <mat-option [value]="type.key">
                {{type.label}}
              </mat-option>
            }
          </mat-select>
          @if (type.invalid && type.touched && type.hasError('required')) {
            <mat-error>Gst Type is required</mat-error>
          }
        </mat-form-field>
        <mat-card-actions>
          <button mat-button color="primary" [disabled]="(!editPermission && id.value) || (!addPermission && !id.value)" (click)="save()">SAVE</button>
          <button mat-button color="cancel" (click)="cancel()">CANCEL</button>
        </mat-card-actions>
        <mat-card-content style="margin-top: 3%;">
          @if (id.value) {
            <div class="audit-log">
              <button mat-stroked-button type="button" [class.active]="viewLog.value"
                  (click)="viewLog.setValue(!viewLog.value)">
                  <mat-icon>history</mat-icon> View Log
              </button>
            </div>
          }
          @if (viewLog.value) {
            <app-history [referenceType]="'GST'" [referenceId]="id.value"></app-history>
          }
        </mat-card-content>
      </mat-card-content>
    </mat-card>
  </form>
</div>